import { onMount, reactive, watch } from 'cdui-js';
import i18n from '../../../i18n';
import { showActionSheet } from '../components/ActionSheet';
import { Countries } from '../components/SelectCountry/Component';
import '../components/SelectBox/style.css';
import '../components/SelectCountry/style.css';
import { crsCountryGroups, crsCountryLabel, loadCrsCountryDict, resolveCrsCountryCode } from './countryDict';

type CrsCountrySelectProps = {
  title?: string;
  placeholder?: string;
  value: string;
  change?: (code: string) => void;
};

/** CRS 国家选择：数据只来自 GET /sys/dict/country，回传 ISO code */
export const CrsCountrySelect = (props: CrsCountrySelectProps) => {
  const state = reactive({ ready: 0, label: '' });
  let actionSheetIns: { close: () => void } | null = null;

  const syncLabel = (raw: string) => {
    state.label = raw ? crsCountryLabel(raw) : '';
  };

  onMount(() => {
    void loadCrsCountryDict().finally(() => {
      state.ready += 1;
      syncLabel(props.value);
    });
  });

  watch(
    () => props.value,
    (value) => {
      const raw = String(value || '');
      if (!raw) {
        state.label = '';
        return;
      }
      const next = crsCountryLabel(raw);
      if (next) state.label = next;
    },
  );

  const displayLabel = () => {
    void state.ready;
    if (state.label) return state.label;
    if (!props.value) return '';
    return crsCountryLabel(props.value);
  };

  const handleClick = () => {
    void loadCrsCountryDict().then(() => {
      state.ready += 1;
      syncLabel(props.value);
      actionSheetIns = showActionSheet({
        title: props.title || i18n.Common.SelectCountryRegion,
        contentClass: 'action-sheet--select-country',
        content: () => (
          <Countries
            value={props.value || resolveCrsCountryCode(state.label)}
            groups={crsCountryGroups()}
            change={(code, item) => {
              const iso = resolveCrsCountryCode(String(item?.code || item?.value || code || ''));
              state.label = String(item?.label || crsCountryLabel(iso) || '');
              props.change?.(iso);
              actionSheetIns?.close();
            }}
          />
        ),
      });
    });
  };

  return (
    <div class="f-select-box" onclick={handleClick}>
      {displayLabel() ? (
        <div class="f-select-box-display">{displayLabel()}</div>
      ) : (
        <div class="f-select-box-placeholder">{props.placeholder || i18n.Common.PleaseSelect}</div>
      )}
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.12525 11.8998C9.51442 12.2827 10.1388 12.2827 10.528 11.8998L14.2899 8.19838C14.8001 7.69631 14.4446 6.82813 13.7288 6.82813H5.92444C5.20858 6.82813 4.85308 7.69631 5.36335 8.19838L9.12525 11.8998Z"
          fill="#A2A7AD"
        />
      </svg>
    </div>
  );
};
